import { useState, useEffect } from 'react';
import { useAtom } from 'jotai';
import { selectedNodePropsAtom } from '@src/atoms';
import { getOnDragEnter, getOnDragOver, getOnDrop, getOnDragLeave, DnDProps } from './dnd';

type UseDnDProps = Pick<DnDProps, 'reactFlowWrapper' | 'reactFlowInstance'>

export const useDnD = ({ reactFlowWrapper, reactFlowInstance }: UseDnDProps) => {
  const [elementsSelectable, setElementsSelectable] = useState(true);
  const [, setSelectedNodeProps] = useAtom(selectedNodePropsAtom);
  const setNodes = reactFlowInstance?.setNodes;


  const onDragEnter = getOnDragEnter({ reactFlowInstance, setElementsSelectable });
  const onDragOver = getOnDragOver({ reactFlowInstance });
  const onDropCapture = getOnDrop({ reactFlowInstance, reactFlowWrapper, setElementsSelectable, setSelectedNodeProps });
  const onDragLeave = getOnDragLeave({ reactFlowInstance, setElementsSelectable });

  useEffect(() => {
    setNodes?.((prevNodes) => {
      return prevNodes.map((node) => {
        return {
          ...node,
          style: {
            ...node.style,
            pointerEvents: elementsSelectable ? 'auto' : 'none',
          }
        };
      });
    });
  }, [elementsSelectable]);

  return {
    onDragEnter,
    onDragOver,
    onDropCapture,
    onDragLeave,
    setElementsSelectable,
    elementsSelectable,
  }
}
